enum OpencityMethods {
  AUTH_PASSWORD_RESET = 'opencity.auth.password.reset',
  AUTH_PASSWORD_RECOVERY = 'opencity.auth.password.recovery',
  AUTH_PASSWORD_UPDATE = 'opencity.auth.password.update',
  ADDRESS_SEARCH = 'opencity.address.search',
  CLASSIFIER_SEARCH = 'opencity.classifier.search',
  MAP_ISSUE_INDEX = 'opencity.map.issue.index',
  ISSUE_CREATE = 'opencity.issue.create',
  ISSUE_UPDATE = 'opencity.issue.update',
  ISSUE_UNCONFIRMED_REJECTED_UPDATE = 'opencity.issue.unconfirmed.rejected.update',
  ISSUE_UNCONFIRMED_IN_WORK_UPDATE = 'opencity.issue.unconfirmed.in_work.update',
  ISSUE_UNCONFIRMED_DONE_UPDATE = 'opencity.issue.unconfirmed.done.update',
  ISSUE_REJECTED_NEW_UPDATE = 'opencity.issue.rejected.new.update',
  ISSUE_REJECTED_CLOSED_UPDATE = 'opencity.issue.rejected.closed.update',
  ISSUE_DONE_UNCONFIRMED_UPDATE = 'opencity.issue.done.unconfirmed.update',
  ISSUE_NEW_IN_WORK_UPDATE = 'opencity.issue.new.in_work.update',
  ISSUE_NEW_DONE_UPDATE = 'opencity.issue.new.done.update',
  ISSUE_TO_PROVIDER_CLOSED_BY_COMMUNAL_UPDATE = 'opencity.issue.to_provider.closed_by_communal.update',
  ISSUE_DONE_CLOSED_BY_COMMUNAL_UPDATE = 'opencity.issue.done.closed_by_communal.update',
  ISSUE_NEW_CLOSED_BY_COMMUNAL_UPDATE = 'opencity.issue.new.closed_by_communal.update',
  ISSUE_NEW_TO_EXECUTE_UPDATE = 'opencity.issue.new.to_execute.update',
  ISSUE_NEW_DELETED_UPDATE = 'opencity.issue.new.deleted.update',
  ISSUE_NEW_DELAYED_UPDATE = 'opencity.issue.new.delayed.update',
  ISSUE_NEW_TO_PROVIDER_UPDATE = 'opencity.issue.new.to_provider.update',
  ISSUE_DELAYED_RESTORED_UPDATE = 'opencity.issue.delayed.restored.update',
  ISSUE_RESTORED_DELAYED_UPDATE = 'opencity.issue.restored.delayed.update',
  ISSUE_RESTORED_TO_PROVIDER_UPDATE = 'opencity.issue.restored.to_provider.update',
  ISSUE_RESTORED_DELETED_UPDATE = 'opencity.issue.restored.deleted.update',
  ISSUE_TO_EXECUTE_DELETED_UPDATE = 'opencity.issue.to_execute.deleted.update',
  ISSUE_TO_EXECUTE_TO_PROVIDER_UPDATE = 'opencity.issue.to_execute.to_provider.update',
  ISSUE_TO_EXECUTE_DELAYED_UPDATE = 'opencity.issue.to_execute.delayed.update',
  ISSUE_TO_PROVIDER_IN_WORK_UPDATE = 'opencity.issue.to_provider.in_work.update',
  ISSUE_TO_PROVIDER_DONE_UPDATE = 'opencity.issue.to_provider.done.update',
  ISSUE_IN_WORK_DONE_UPDATE = 'opencity.issue.in_work.done.update',
  ISSUE_DONE_DELETED_UPDATE = 'opencity.issue.done.deleted.update',
  ISSUE_DONE_TO_PROVIDER_UPDATE = 'opencity.issue.done.to_provider.update',
  ISSUE_DONE_OK_UPDATE = 'opencity.issue.done.ok.update',
  ISSUE_DONE_CLOSED_UPDATE = 'opencity.issue.done.closed.update',
  ISSUE_RESTORED_DONE_UPDATE = 'opencity.issue.restored.done.update',
  ISSUE_OK_UNCONFIRMED_UPDATE = 'opencity.issue.ok.unconfirmed.update',
  ISSUE_OK_CLOSED_BY_CITIZEN_UPDATE = 'opencity.issue.ok.closed_by_citizen.update',
  ISSUE_OK_CLOSED_UPDATE = 'opencity.issue.ok.closed.update',
  ISSUE_OK_CLOSED_BY_STD_UPDATE = 'opencity.issue.ok.closed_by_std.update',
  ISSUE_OK_CLOSED_AUTO_UPDATE = 'opencity.issue.ok.closed_auto.update',
  ISSUE_UNCONFIRMED_TO_EXECUTE_UPDATE = 'opencity.issue.unconfirmed.to_execute.update',
  ISSUE_UNCONFIRMED_TO_PROVIDER_UPDATE = 'opencity.issue.unconfirmed.to_provider.update',
  ISSUE_UNCONFIRMED_CLOSED_BY_ANALYST_UPDATE = 'opencity.issue.unconfirmed.closed_by_analyst.update',
  ISSUE_TO_PROVIDER_DELETED_UPDATE = 'opencity.issue.to_provider.deleted.update',
  ISSUE_TO_PROVIDER_DELAYED_UPDATE = 'opencity.issue.to_provider.delayed.update',
  ISSUE_DELETED_RESTORED_UPDATE = 'opencity.issue.deleted.restored.update',
  ISSUE_NEW_REJECTED_UPDATE = 'opencity.issue.new.rejected.update',
  ISSUE_INDEX = 'opencity.issue.index',
  ISSUE_COUNT = 'opencity.issue.count',
  ISSUE_EXPORT = 'opencity.issue.export',
  ISSUE_COMMENT_INDEX = 'opencity.issue.comment.index',
  ISSUE_DOCUMENT_CREATE = 'opencity.issue.document.create',
  ISSUE_DOCUMENT_INDEX = 'opencity.issue.document.index',
  ISSUE_RECORD_GET_URL = 'opencity.issue.record.get_url',
  ISSUE_STATISTICS_DYNAMICS = 'opencity.issue.statistics.dynamics',
  ISSUE_STATISTICS_TOP_BY_CONTROL = 'opencity.issue.statistics.top_by_control',
  FLAT_ACCOUNT_INDEX = 'opencity.flat.account.index',
  FLAT_ACCOUNT_COUNT = 'opencity.flat.account.count',
  FLAT_ACCOUNT_OWNER_CREATE = 'opencity.flat.account.owner.create',
  FLAT_ACCOUNT_OWNER_UPDATE = 'opencity.flat.account.owner.update',
  FLAT_ACCOUNT_GET_LAST_APPLICANT = 'opencity.flat.account.get_last_applicant',
  USER_COUNT = 'opencity.user.count',
  USER_CREATE = 'opencity.user.create',
  USER_INDEX = 'opencity.user.index',
  USER_DELETE = 'opencity.user.delete',
  USER_CATEGORY_INDEX = 'opencity.user.category.index',
  USER_RULE_UPDATE = 'opencity.user.rule.update',
  USER_NOTIFICATION_UNSUBSCRIBE = 'opencity.user.notification.unsubscribe',
  ORGANIZATION_COUNT = 'opencity.organization.count',
  ORGANIZATION_INDEX = 'opencity.organization.index',
  ORGANIZATION_DISTRICT_INDEX = 'opencity.organization.district.index',
  ORGANIZATION_RATING_INDEX = 'opencity.organization.rating.index',
  ORGANIZATION_PREFERABLE_INDEX = 'opencity.organization.preferable.index',
  INTERRUPT_INDEX = 'opencity.interrupt.index',
  INTERRUPT_COUNT = 'opencity.interrupt.count',
  INTERRUPT_CREATE = 'opencity.interrupt.create',
  INTERRUPT_UPDATE = 'opencity.interrupt.update',
  PROFILE_INDEX = 'opencity.profile.index',
  PROFILE_CREATE = 'opencity.profile.create',
  PROFILE_UPDATE = 'opencity.profile.update',
  PROFILE_DELETE = 'opencity.profile.delete',
  PROFILE_ACCOUNT_CREATE = 'opencity.profile.account.create',
  PROFILE_ACCOUNT_DELETE = 'opencity.profile.account.delete',
  AVATAR_CREATE = 'opencity.profile.avatar.create',
  AVATAR_DELETE = 'opencity.profile.avatar.delete',
  AVATAR_INDEX = 'opencity.profile.avatar.index',
  AVATAR_UPDATE = 'opencity.profile.avatar.update',
  GIS_STREET_INDEX = 'opencity.gis.street.index',
  GIS_STREET_COUNT = 'opencity.gis.street.count',
  GIS_HOUSE_INDEX = 'opencity.gis.house.index',
  GIS_HOUSE_COUNT = 'opencity.gis.house.count',
  GIS_FLAT_INDEX = 'opencity.gis.flat.index',
  GIS_FLAT_COUNT = 'opencity.gis.flat.count',
  GIS_DISTRICT_INDEX = 'opencity.gis.district.index',
  GIS_DISTRICT_COUNT = 'opencity.gis.district.count',
  USER_STREET_INDEX = 'opencity.user.street.index',
  USER_HOUSE_INDEX = 'opencity.user.house.index',
  USER_FLAT_INDEX = 'opencity.user.flat.index',
  DEVICE_METERING_INDEX = 'opencity.device.metering.index',
  DEVICE_METERING_REFRESH = 'opencity.device.metering.refresh',
  DEVICE_METERING_VALUE_INDEX = 'opencity.device.metering.value.index',
  DEVICE_METERING_VALUE_CREATE = 'opencity.device.metering.value.create',
  FILE_CREATE = 'opencity.file.create',
  FILE_INDEX = 'opencity.file.index',
  REFERENCE_INTERRUPT_REASON_INDEX = 'opencity.reference.interrupt.reason.index',
  REFERENCE_INTERRUPT_SENDER_INDEX = 'opencity.reference.interrupt.sender.index',
  REFERENCE_INTERRUPT_TYPE_INDEX = 'opencity.reference.interrupt.type.index',
  REFERENCE_CLASSIFIER_CATEGORY_INDEX = 'opencity.reference.classifier.category.index',
  REFERENCE_CLASSIFIER_TRACKER_INDEX = 'opencity.reference.classifier.tracker.index',
  REFERENCE_CLASSIFIER_TYPE_INDEX = 'opencity.reference.classifier.type.index',
  REFERENCE_CLASSIFIER_TAG_INDEX = 'opencity.reference.classifier.tag.index',
  FEEDBACK_CREATE = 'opencity.feedback.create',

  AUTH_OPERATION_ALLOWED = '_auth.operation.allowed',
  REPORT_INTERRUPT_CREATE = 'opencity.report.interrupt.create',
  REPORT_INTERRUPT_EXTENDED_CREATE = 'opencity.report.interrupt.extended.create',
  REPORT_INTERRUPT_SENDER_CREATE = 'opencity.report.interrupt.sender.create',
  REPORT_INTERRUPT_CONTROL_CREATE = 'opencity.report.interrupt.control.create',
  REPORT_ISSUE_OPERATOR_CREATE = 'opencity.report.issue.operator.create',
  REPORT_COUNTER_CREATE = 'opencity.report.counter.create',
  REPORT_ACCOUNT_CREATE = 'opencity.report.account.create',
  REPORT_ISSUE_CHECKERBOARD = 'opencity.report.issue.checkerboard',
  REPORT_ISSUE_FOOTCLOTH = 'opencity.report.issue.footcloth',
  REPORT_ISSUE_CREATE = 'opencity.report.issue.create',
  REPORT_INDEX = 'opencity.report.index',

  AUTH_PROVIDER_GET_URL = 'opencity.auth.provider.get_url',
  AUTH_PROVIDER_LOGIN = 'opencity.auth.provider.login',
  ISSUE_CHANGE_PROVIDER = 'opencity.issue.change_provider',
  ISSUE_CHANGE_CLASSIFIER = 'opencity.issue.change_classifier',
  CACHE_ISSUE_COUNT = 'opencity.cache.issue.count',
  USER_CODE_GENERATE = 'opencity.user.code.generate',
  USER_CODE_CONFIRM = 'opencity.user.code.confirm',
  USER_CODE_VALIDATE = 'opencity.user.code.validate',
  AUTH_LOGIN_EXIST = 'opencity.auth.login.exist',

  USER_NOTIFICATION_DELETE = 'opencity.user.notification.delete',
  USER_CODE_GET_NEXT_TIME = 'opencity.user.code.get_next_time',

  ISSUE_COMMENT_CREATE = 'opencity.issue.comment.create',

  ISSUE_VIEW = 'opencity.issue.view',

  ISSUE_NOTICE = 'opencity.issue.notice',

  USER_PREFERENCE_UPDATE = 'opencity.user.preference.update',
  USER_PREFERENCE_INDEX = 'opencity.user.preference.index',
  CAPTCHA_CHECK = 'opencity.captcha.check',

  ISSUE_STATISTICS_INDEX = 'opencity.issue.statistics.index',
  ISSUE_STATISTICS_TOP_BY_HOUSE = 'opencity.issue.statistics.top_by_house',

  OVERHAUL_INDEX = 'opencity.overhaul.index',
}

export default OpencityMethods;
